import { render, staticRenderFns } from "./VAuctionsStatisticalCard.vue?vue&type=template&id=02cadd2e"
import script from "./VAuctionsStatisticalCard.vue?vue&type=script&lang=js"
export * from "./VAuctionsStatisticalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports